import { animate, AnimationMetadata, AnimationPlayer, style } from "@angular/animations";
import { AfterViewInit, Directive, ElementRef, HostListener } from "@angular/core";
import { AnimationBuilder } from "@angular/animations";

@Directive({
  selector: 'img[image-fade-in]'
})
export class ImageFadeInDirective implements AfterViewInit {
  private player: AnimationPlayer;

  @HostListener('load') onLoad() {
    if (this.player) {
      this.player.destroy();
    }

    const metadata = this.fadeIn();

    const factory = this.builder.build(metadata);
    const player = factory.create(this.el.nativeElement, {
      params: {

      }
    });

    player.play();
  }

  constructor(private builder: AnimationBuilder, private el: ElementRef<HTMLImageElement>) { }

  ngAfterViewInit(): void {
    this.el.nativeElement.style.opacity = '0';
  }

  private fadeIn(): AnimationMetadata[] {
    return [
      style({ opacity: 0 }),
      animate('300ms ease-in', style({ opacity: 1 })),
    ];
  }
}
